import React, { ReactNode, createContext, useEffect } from "react";
import { useConfigStore, persistStore } from "./store";
import { ConfigInterface, PersistState } from "./types";

interface ConfigProviderProps {
    children: ReactNode;
}

interface PersistStateSetup {
    reset: number;
}

const PersistStateData: PersistStateSetup = {
    reset: 1,
};

export const StoreContext = createContext<ConfigInterface | null>(null);


export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }: ConfigProviderProps) => {
    const production = useConfigStore((state) => state.production);
    const language = useConfigStore((state) => state.language);
    const shownFalse = persistStore((state) => state.changeValue);
    const init = persistStore((state: PersistState) => state.init);

    useEffect(() => {
        if (!production) {
            shownFalse("shown", false);
        }
        init(PersistStateData.reset, language === "pl" || language === "es");
    }, [production, shownFalse, init, language]);

    return (
        <StoreContext.Provider value={useConfigStore.getState()}>
            {children}
        </StoreContext.Provider>
    );
};
